import type { Notification } from '@frontend/api/src/notifications/types';
import {
  Part,
  PartThumbnail,
  PartThumbnailFromBlob,
  PartThumbnailContainer,
} from '@frontend/components';

const NotificationThumbnail = ({
  notification,
  thumbnailBlob,
}: {
  notification: Notification;
  thumbnailBlob?: Blob | null;
}) => {
  const thumbnailProps = {
    containsVirus: notification.containsVirus ?? false,
    fileType: notification.fileType ?? '',
    loadLazily: false,
  };

  return (
    <Part border="none" padding={0}>
      <PartThumbnailContainer w="60px" maxW="60px" minW="60px" height="100%">
        {thumbnailBlob ? (
          <PartThumbnailFromBlob
            {...thumbnailProps}
            thumbnailBlob={thumbnailBlob}
          />
        ) : (
          <PartThumbnail
            {...thumbnailProps}
            partFileUuid={notification.partFileUuid}
          />
        )}
      </PartThumbnailContainer>
    </Part>
  );
};

export default NotificationThumbnail;
